import React, { Component, useEffect } from "react";
import PropTypes from "prop-types";
import { Box } from "native-base";
import NavigationComp from "./NavigationComp";


class PageNotFound extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageName: this.props.pageName,
    };
  }

  render() {
    sessionStorage.clear();
    return (
      <Box>
        {this.state.pageName} , Page Not Found.
        <NavigationComp pageName="/" />
      </Box>
    );
  }
}

export default PageNotFound;
